// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"744":"0b22195dc5f41a0e","5973":"923a65d51d9ec802"}[chunkId] + ".css";
};